import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["code", "message"];

  copy() {
    navigator.clipboard.writeText(this.codeTarget.textContent.trim()).then(() => {
      this.messageTarget.classList.remove("hidden");
      setTimeout(() => this.messageTarget.classList.add("hidden"), 2000);
    });
  }
}
